import React from 'react';
import * as styles from "./styles.module.scss";

const ErrorPage = () => {
    return (
        <h1 className={styles.errorPage}>404</h1>
    )
}

export default ErrorPage;